import parsePriceAggregate from '@/scenes/Search/useCases/aggregates/parsePriceAggregate'

import { SEARCH_AGGREGATES } from '@/utils/constants'
import { FilterPriceProps } from '~types/search'
import SliderRange from './SliderRange'
import SliderSingle from './SliderSingle'

const FilterPrice = ({
  buckets,
  defaultValue,
  onChange,
  currencyLocale,
  currencyFormat,
}: FilterPriceProps) => {
  const { range, formatTooltip, rangeValue, singleValue, ...sliderProps } =
    parsePriceAggregate({
      buckets,
      defaultValue,
      currencyLocale,
      currencyFormat,
    })

  const handleChange = (value: number[]) => {
    if (Array.isArray(value)) {
      onChange(SEARCH_AGGREGATES.priceRanges, { gte: value[0], lte: value[1] })
    }
  }
  const SliderComponent = range ? SliderRange : SliderSingle

  return (
    <SliderComponent
      className="filter-aggregate filter-aggregate-price"
      onChangeGeneric={handleChange}
      tooltip={{ formatter: (value?: number) => formatTooltip(value ?? 0) }}
      sliderValue={range ? rangeValue : [singleValue]}
      {...sliderProps}
    />
  )
}

export default FilterPrice
